import { render } from "./Dropdown.vue?vue&type=template&id=537005e3"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script